<template>
  <div
    :class="['folder-thumbnail-card', { big: size === 'big' }]"
    @click="goToFolder"
  >
    <template v-if="size === 'big'">
      <div v-if="$slots.menu" class="folder-menu big-menu">
        <slot name="menu" />
      </div>

      <div class="folder-icon big-icon">
        <eg-icon
          :icon="isFolder ? 'folder-filled' : 'file-document'"
          size="large"
        />
      </div>

      <div class="folder-info big-info">
        <!-- TODO: detect if name truncated then show tooltip -->
        <div
          v-b-tooltip.hover
          class="folder-title big-title text-truncate"
          :title="name.length > 12 ? name : undefined"
        >
          {{ name }}
        </div>
        <div v-if="!isFolder" class="folder-subtitle big-subtitle">
          {{ itemsCount }} {{ entity }}
        </div>
      </div>
    </template>

    <template v-else>
      <div class="folder-icon">
        <eg-icon
          :icon="isFolder ? 'folder-filled' : 'file-document'"
          size="large"
        />
      </div>

      <div class="folder-info">
        <div class="folder-title text-truncate">
          {{ name }}
        </div>
        <div v-if="!isFolder" class="folder-subtitle">
          {{ itemsCount }} {{ entity }}
        </div>
      </div>

      <div class="folder-menu ml-auto">
        <slot name="menu">
          <folder-actions-dropdown
            :folder-id="folderId"
            :workspace-key="workspaceKey"
          />
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
import FolderActionsDropdown from "@/components/global/folder_actions_dropdown.vue";

export default {
  name: "FolderThumbnail",

  components: {
    FolderActionsDropdown,
  },

  props: {
    folderId: {
      type: Number,
      required: true,
    },
    workspaceKey: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "Folder",
    },
    entity: {
      type: String,
      default: "essays",
    },
    itemsCount: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: "horizontal",
    },
    isFolder: {
      type: Boolean,
      default: true,
    },
    hasGradingDetails: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    goToFolder() {
      const routeName =
        !this.isFolder && !this.hasGradingDetails
          ? "workspace-essay-upload"
          : "workspace";

      this.$router.push({ name: routeName, params: { id: this.folderId } });
    },
  },
};
</script>

<style lang="scss" scoped>
.folder-thumbnail-card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(20, 20, 43, 0.06);
  padding: 16px 12px;
  width: 244px;
  max-height: 64px;
  gap: 8px;
  position: relative;
  cursor: pointer;

  &.big {
    flex-direction: column;
    align-items: flex-start;
    width: 248px;
    height: 136px;

    .big-menu {
      position: absolute;
      top: 10px;
      right: 10px;
      margin-left: 0;
      z-index: 2;
    }
    .big-icon {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      background: none;
    }
    .big-info {
      width: 100%;
      text-align: center;
      margin-bottom: 0;
    }
    .big-title {
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      letter-spacing: 0px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .big-subtitle {
      font-size: 0.92rem;
      color: #888;
      margin-top: 0;
    }
  }
}
.folder-icon {
  flex-shrink: 0;
  display: flex;
  width: 32px;
  align-items: center;
  justify-content: center;
  color: var(--color-icon-primary-primary);
}
.folder-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.folder-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
}
.folder-subtitle {
  color: #888;
  margin-top: 2px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0px;
}
.folder-menu {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
}
.big-ellipsis {
  font-size: 1.3rem;
  color: #bbb;
  user-select: none;
}
</style>
